enum ReportTypeStatus {
  SERVICE_INTERRUPTED = 'SERVICE_INTERRUPTED',
  SERVICE_DEGRADED = 'SERVICE_DEGRADED',
  SAV = 'SAV',
  NO_STATUS = 'NO_STATUS'
}

export default ReportTypeStatus;
